import {
  ArrowDown2,
  ArrowUp2,
  Bag2,
  LogoutCurve,
  UserSquare,
} from 'iconsax-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import Text from '../../../../assets/styles/Text';
import { useStore } from '../../../../stores';
import { cartStore } from '../../../../stores/cartStore';
import Cart from '../../../Cart';
import * as styles from './styles';

export default function LinkDesktop() {
  const [registerShow, setRegisterShow] = useState(false);
  const [loginShow, setLoginShow] = useState(false);

  const { logout, user } = useStore(
    useShallow((state) => ({
      logout: state.logout,
      user: state.user,
    }))
  );
  const { showCart, openCart } = cartStore();

  function handleRegisterShow() {
    setLoginShow(false);
    setRegisterShow((prevState) => !prevState);
  }

  function handleLoginShow() {
    setRegisterShow(false);
    setLoginShow((prevState) => !prevState);
  }

  if (!user) {
    return (
      <styles.Container className="desktop">
        <styles.ButtonLink onClick={handleRegisterShow}>
          <div>
            <Text.Span>Faça seu cadastro</Text.Span>
            <Text.Span className="red">100% grátis</Text.Span>
          </div>

          <ArrowDown2 />

          {registerShow && (
            <styles.GroupLogin>
              <div>
                <div>
                  <Text.Span>Faça seu cadastro</Text.Span>
                  <Text.Span className="red">100% grátis</Text.Span>
                </div>

                <ArrowUp2 />
              </div>
              <Link to="/clientregister">
                <Text.Span>Quero ser cliente</Text.Span>
              </Link>
              <Link to="/modelregister">
                <Text.Span>Quero ser acompanhante</Text.Span>
              </Link>
            </styles.GroupLogin>
          )}
        </styles.ButtonLink>

        <styles.ButtonLink onClick={handleLoginShow}>
          <Text.Span>Login</Text.Span>

          <ArrowDown2 />

          {loginShow && (
            <styles.GroupLogin>
              <div>
                <Text.Span>Login</Text.Span>
                <ArrowUp2 />
              </div>
              <Link to="/clientlogin">
                <Text.Span>Entrar como cliente</Text.Span>
              </Link>
              <Link to="/modellogin">
                <Text.Span>Entrar como modelo</Text.Span>
              </Link>
            </styles.GroupLogin>
          )}
        </styles.ButtonLink>
      </styles.Container>
    );
  }

  return (
    <styles.Container className="desktop">
      <Cart show={showCart} price={200} />

      <button type="button" onClick={logout}>
        <LogoutCurve size={28} />
      </button>

      {user?.type === 'model' && (
        <button type="button" onClick={openCart}>
          <Bag2 size={28} />
        </button>
      )}
      <Link to={`/${user?.type}dashboard`}>
        <UserSquare size={28} />
      </Link>
    </styles.Container>
  );
}
